import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery, gql } from '@apollo/client';
import ArtistPostList from '../components/ArtistPostList';
import ProfilePicture from '../components/ProfilePicture';
import AudioPlayer from '../components/AudioPlayer';
import ShowsByArtist from '../components/ShowsByArtist';
import './ArtistPage.css';
import PublicMerchandiseDetailPage from './PublicMerchandiseDetailPage';

const GET_ARTIST_PAGE = gql`
  query GetArtistPage($input: ArtistPagesInput) {
    allArtistPages(input: $input) {
      id
      title
      description
      ownerId
      profileImage
    }
  }
`;

const GET_ALBUMS_BY_ARTIST = gql`
  query GetAlbumsByArtist($artistPageId: ID!) {
    getAlbumsByArtist(artistPageId: $artistPageId) {
      id
      title
      songs {
        id
        title
      }
    }
  }
`;

const ArtistPage = () => {
  const { id } = useParams();
  const token = sessionStorage.getItem('token');
  const [selectedTab, setSelectedTab] = useState('posts');

  const { loading, error, data } = useQuery(GET_ARTIST_PAGE, {
    variables: { input: { id: parseInt(id) } },
  });

  const {
    loading: albumsLoading,
    error: albumsError,
    data: albumsData,
  } = useQuery(GET_ALBUMS_BY_ARTIST, {
    variables: { artistPageId: parseInt(id) },
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });

  if (loading || albumsLoading) return <p style={{ color: 'white' }}>Loading...</p>;
  if (error || albumsError) return <p style={{ color: 'white' }}>Error: {error?.message || albumsError?.message}</p>;

  const artist = data.allArtistPages[0];
  if (!artist) {
    return (
      <div className="artist-page-container" style={{ color: 'white', padding: '2rem' }}>
        <h2>Artist Not Found</h2>
        <p>This artist does not exist or may have been removed.</p>
        <p>Please check the URL or return to the <a href="/" style={{ color: '#61dafb' }}>home page</a>.</p>
      </div>
    );
  }
  const albums = albumsData?.getAlbumsByArtist || [];



  return (
    <div className="artist-page-container">
      <ProfilePicture profileImage={artist.profileImage} />
      <h1>{artist.title}</h1>
      <p>{artist.description || "Coming soon: artist bio, merch, posts, and more!"}</p>

      <div className="artist-tabs">
        <button className={selectedTab === 'posts' ? 'active' : ''} onClick={() => setSelectedTab('posts')}>📢 Socials</button>
        <button className={selectedTab === 'music' ? 'active' : ''} onClick={() => setSelectedTab('music')}>🎵 Music</button>
        <button className={selectedTab === 'shows' ? 'active' : ''} onClick={() => setSelectedTab('shows')}>🎫 Shows</button>
        <button className={selectedTab === 'products' ? 'active' : ''} onClick={() => setSelectedTab('products')}>🎫 Merchandise</button>
      </div>

      {selectedTab === 'posts' && (
        <div className="artist-tab-content">
          <ArtistPostList artistPageId={id} />
        </div>
      )}

      {selectedTab === 'music' && (
        <div className="artist-tab-content">
          {albums.length === 0 ? (
            <p>No albums yet.</p>
          ) : (
            albums.map((album) => (
              <div key={album.id} className="album-section">
                <h3>{album.title}</h3>
                {album.songs.length === 0 ? (
                  <p>No songs in this album.</p>
                ) : (
                  album.songs.map((song) => (
                    <AudioPlayer key={song.id} song={song} token={token} />
                  ))
                )}
              </div>
            ))
          )}
        </div>
      )}

      {selectedTab === 'shows' && (
        <div className="artist-tab-content">
          <ShowsByArtist artistPageId={id} />
        </div>
      )}
      {selectedTab === 'products' && (
        <div className="artist-tab-content">
          
          <PublicMerchandiseDetailPage/>
        </div>
      )}
    </div>
  );
};

export default ArtistPage;
